export const DEFAULT_USER_AUTH_TOKEN: string = "";
export const REFRESH_DATA_INTERVAL_IN_MILISECONDS: number = 60000;
